export default {
  PATH: 'path',
  PAGE: 'page',
  ANCHOR: 'anchor',
  DOWNLOAD: 'download',
  PHONE: 'phone',
  EXTERNAL: 'external',
  MAIL: 'mail',
  NO_ACTION: 'no_action',
  VIEW_FULL_SIZE_IMAGE: 'view_full_size_image',
  SOCIAL_MEDIA: 'social_media',
  WHATS_APP: 'whats_app',
};
